import SideNav from 'CoreComponents/sideNav/';

// Setup the side nav only if it's there
if (document.querySelector('.side-nav')) {
  new SideNav();
}
